import angular from 'angular';
import { AddressModule } from '@updater-components/address';
import { GetStartedAddressComponent } from './address.component';
import { GetStartedAddressConfig } from './address.config';
import form from '../get-started-form';

export const GetStartedAddressModule = angular
  .module('app.get-started.address', [form.name, AddressModule.name])
  .config(GetStartedAddressConfig)
  .component('updGetStartedAddress', GetStartedAddressComponent);
